import _get from 'lodash/get';
import fetch from 'cross-fetch';
import isNode from '../ajio-util/isNode';
import { gaSendEvent } from '../ga';
import { getHostName } from '../../utils/sisUtils';
import loggerInstance from '../logger/logger';

function triggerGAEvent(args, error) {
  const eventCategory = 'errors interactions';
  const { message = '', name = 'FetchError', status } = error;
  const urlRegex = /(https?:\/\/[^ ]*)/;
  const regexMatch = message.match(urlRegex);
  const eventAction = _get(args, '0', _get(regexMatch, '0', name));
  const action = 'service error';
  const eventLabel = `${eventAction}: ${message}`;
  let store = 'AJIO';
  if (!isNode()) {
    const { origin } = window?.location;
    store = getHostName(origin) || 'AJIO';
  }
  gaSendEvent(eventCategory, action, eventLabel, status, store, 'errors_interactions');
}

function fetcherForNode(args) {
  const initialTime = Date.now();
  return fetch(...args)
    .then(response => {
      const finalTime = Date.now();
      const timeTaken = finalTime - initialTime;
      loggerInstance.logFetcherInfo(args, response, timeTaken);
      return Promise.resolve(response);
    })
    .catch(error => {
      const finalTime = Date.now();
      const timeTaken = finalTime - initialTime;
      loggerInstance.logFetcherError(args, error, timeTaken);
      // triggerGAEvent(args, error);
      return Promise.reject(error);
    });
}

function fetcherForClient(args) {
  return fetch(...args)
    .then(response => {
      const { status = '', statusText = '' } = response;
      if (status !== 200) {
        triggerGAEvent(args, { status, message: statusText });
      }
      return Promise.resolve(response);
    })
    .catch(error => {
      triggerGAEvent(args, error);
      return Promise.reject(error);
    });
}

const fetcher = (...args) => (isNode() ? fetcherForNode(args) : fetcherForClient(args));

export default fetcher;
